import React from 'react';
import './ui.css';

/**
 * SectionCard — surface used to group related content on dashboards.
 * Props: title, action (node | string), onAction, interactive, onClick
 */
export default function SectionCard({
  title,
  action,
  onAction,
  interactive = false,
  onClick,
  className = '',
  children,
}) {
  const cls = [
    'ui-section-card',
    interactive ? 'ui-section-card--interactive' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <section className={cls} onClick={interactive ? onClick : undefined}>
      {(title || action) && (
        <div className="ui-section-card__header">
          {title && <h2 className="ui-section-card__title">{title}</h2>}
          {action && (
            typeof action === 'string'
              ? <button type="button" className="ui-section-card__action" onClick={onAction}>{action}</button>
              : action
          )}
        </div>
      )}
      {children}
    </section>
  );
}
